import { createCommand } from 'lexical'

export const INSERT_QUOTE_COMMAND = createCommand<void>('INSERT_QUOTE_COMMAND')
